import store from "../redux/app/store";

import {
  setPatientId,
  setPatientUniqueID,
  setPatientFullName,
} from "../redux/features/patientState/patientStateSlice";
import {
  setMenuOpen,
  setActiveMenu,
  setActivePage,
  setActivePatientSidebarGroup,
} from "../redux/features/applicationState/applicationStateSlice";

import toastManager from "./toastManager";

const entrySidebarGroups = {
  photo: "photo",
  comparison: "photo",
  psoriasis: "psoriasisAiAssisted",
  psoriasis_segmentation: "psoriasisAiAssisted",
  segmentation: "aiAssisted",
};

export const handleRapidEntrySave = ({
  response,
  pageLink,
  activePage,
  navigate,
  entryType,
}) => {
  const patientIdResponse = response?.payload?.patient_id || "";
  const patientUniqueIdResponse = response?.payload?.patient_unique_id || "";
  const patientFullNameResponse = response?.payload?.patient_full_name || "";

  store.dispatch(setActivePage(activePage + patientIdResponse));
  store.dispatch(setMenuOpen(true));
  store.dispatch(setActiveMenu("patients"));
  store.dispatch(setActivePatientSidebarGroup(entrySidebarGroups[entryType]));

  store.dispatch(setPatientId(patientIdResponse));
  store.dispatch(setPatientUniqueID(patientUniqueIdResponse));
  store.dispatch(setPatientFullName(patientFullNameResponse));

  navigate(pageLink);

  toastManager(
    "success",
    "Rapid Entry Saved!",
    "Rapid entry has been successfully converted to a regular entry."
  );
};
